import { render, staticRenderFns } from "./richTextInput.vue?vue&type=template&id=bf64f9ee&scoped=true&"
import script from "./richTextInput.vue?vue&type=script&lang=ts&"
export * from "./richTextInput.vue?vue&type=script&lang=ts&"
import style0 from "./richTextInput.vue?vue&type=style&index=0&id=bf64f9ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf64f9ee",
  null
  
)

export default component.exports